<template>
  <div class="mt-4">
    <main-toolbar>
      <v-toolbar-title>Support</v-toolbar-title>
    </main-toolbar>
    <div class="text-center" v-if="skinProp('key') === 'sigma'">
      <img src="img/support.png" />
      <br />
      <br />
      <h1>SIGMA PACK-RITE SUPPORT POWERED BY HIGHLIGHT</h1>
      <p>Email: <a href="mailto:techsupport@highlightindustries.com">techsupport@highlightindustries.com</a></p>
      <p>Tel: 1.800.531.2465</p>

      <p>Address:</p>
      2694 Prarie St SW
      <br />Wyoming, MI. 49519
    </div>
    <div class="text-center" v-else>
      <img src="img/support.png" />
      <br />
      <br />
      <h1>HiLIFE SUPPORT</h1>
      Email: <a href="mailto:techsupport@highlightindustries.com">techsupport@highlightindustries.com</a>

      <p>Tel: 1.800.531.2465</p>

      <p>Address:<br />
      2694 Prairie St SW<br />
      Wyoming, MI 49519</p>
    </div>
  </div>
</template>

<script>
export default {
}
</script>
